export const ChartSkeleton = () => {
  return (
    <div className="space-y-3 animate-pulse">
      <div className="h-4 bg-muted rounded w-1/3"></div>
      <div className="h-64 bg-muted rounded"></div>
      <div className="flex gap-4">
        <div className="h-3 bg-muted rounded w-1/4"></div>
        <div className="h-3 bg-muted rounded w-1/4"></div>
      </div>
    </div>
  );
};
